/**
 * LifecycleControls
 *
 * Playback controls for the Fire Lifecycle Visualizer.
 * Buttons: step back | play/pause | step forward
 * Speed selector: 0.5x / 1x / 2x
 */
import React from 'react';
import type { AnimationSpeed } from '../../../../hooks/useLifecycleAnimation';

interface LifecycleControlsProps {
  playing: boolean;
  speed: AnimationSpeed;
  onPlay: () => void;
  onPause: () => void;
  onStepForward: () => void;
  onStepBack: () => void;
  onSetSpeed: (speed: AnimationSpeed) => void;
}

const SPEEDS: AnimationSpeed[] = [0.5, 1, 2];

export const LifecycleControls: React.FC<LifecycleControlsProps> = ({
  playing,
  speed,
  onPlay,
  onPause,
  onStepForward,
  onStepBack,
  onSetSpeed,
}) => {
  return (
    <div className="lifecycle-controls">
      <div className="lifecycle-controls__playback">
        <button
          className="lifecycle-controls__btn"
          onClick={onStepBack}
          aria-label="Step back one day"
          title="Step back"
        >
          &#9664;&#9664;
        </button>

        <button
          className="lifecycle-controls__btn lifecycle-controls__btn--play"
          onClick={playing ? onPause : onPlay}
          aria-label={playing ? 'Pause' : 'Play'}
          title={playing ? 'Pause' : 'Play'}
        >
          {playing ? '\u23F8' : '\u25B6'}
        </button>

        <button
          className="lifecycle-controls__btn"
          onClick={onStepForward}
          aria-label="Step forward one day"
          title="Step forward"
        >
          &#9654;&#9654;
        </button>
      </div>

      <div className="lifecycle-controls__speed" role="group" aria-label="Playback speed">
        {SPEEDS.map(s => (
          <button
            key={s}
            className={`lifecycle-controls__speed-btn${speed === s ? ' lifecycle-controls__speed-btn--active' : ''}`}
            onClick={() => onSetSpeed(s)}
            aria-pressed={speed === s}
            aria-label={`Speed ${s}x`}
          >
            {s}x
          </button>
        ))}
      </div>
    </div>
  );
};
